// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DL-nq","select":"styles_select__RGMi7"};